import { Component, OnInit } from '@angular/core';
import { MenuItem, SelectItem } from 'primeng/api';

import { BreadcrumbMain, CalendarType, CommonTransformationService, RouteLink } from '@app/shared';

@Component({
  selector: 'app-corp-calendar',
  templateUrl: './corp-calendar.component.html',
  styleUrls: ['./corp-calendar.component.css']
})
export class CorpCalendarComponent implements OnInit {
  RouteLink: typeof RouteLink = RouteLink;

  breadcrumb: MenuItem[] = [];

  calendarType: SelectItem[];
  selectedCalendarType: CalendarType = CalendarType.Holiday;       //ToDo jC: use user preference later on
  calendarYear = new Date().getFullYear();

  constructor (private transform: CommonTransformationService) {
  }

  ngOnInit() {
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push({ label: 'Corporate Calendar', routerLink: RouteLink.CorpCalendar });

    this.calendarType = this.transform.convertEnumToDropDown(CalendarType);
  }
}
